import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../context/AuthContext";
import { ArrowUpRight } from "lucide-react";

export default function GamesSection() {
  const [games, setGames] = useState([]);
  useEffect(() => {
    api.get("/games").then((r) => setGames(r.data.games || [])).catch(() => {});
  }, []);

  return (
    <section id="games" className="relative px-6 md:px-10 py-32">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between flex-wrap gap-4">
          <div>
            <div className="text-[12px] uppercase tracking-[0.25em] text-white/40">The catalog</div>
            <h2 className="mt-3 text-[44px] md:text-[64px] font-black tracking-[-0.03em] leading-[1]">Now playing.</h2>
          </div>
          <div className="text-[13px] text-white/50">{games.length} live on Stake</div>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
          {games.map((g, i) => (
            <Link key={g.slug} to={`/games/${g.slug}`} className="group glass rounded-3xl overflow-hidden hover:-translate-y-1 transition-transform duration-300">
              <div className="relative aspect-[3/4] overflow-hidden">
                {g.cover ? (
                  <img src={g.cover} alt={`${g.title} game tile`} loading="lazy" className="absolute inset-0 w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-[1.03] transition-all duration-500" />
                ) : (
                  <div className="absolute inset-0 flex items-center justify-center" style={{ background: "linear-gradient(160deg, #1a0a12 0%, #0a0a0f 100%)" }}>
                    <div className="text-center px-6">
                      <div className="text-[11px] uppercase tracking-widest text-white/40">Coming soon</div>
                      <div className="mt-2 text-3xl font-black text-white/80 tracking-tight">{g.title}</div>
                    </div>
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
                <div className="absolute top-4 left-4 text-[11px] tracking-widest text-white/70">FIG. {String(i + 1).padStart(2, "0")}</div>
                <div className="absolute bottom-5 left-5 right-5">
                  <div className="text-[11px] tracking-[0.2em] text-white/50">{g.genre}</div>
                  <div className="mt-1 text-[22px] font-bold tracking-tight text-white leading-tight">{g.title}</div>
                </div>
              </div>
              <div className="flex items-center justify-between px-5 py-4">
                <div className="text-[13px] text-white/60">RTP {g.rtp} &middot; {g.max_win}</div>
                <div className="flex items-center gap-1 text-[13px] text-white/80 group-hover:text-white transition-colors">View <ArrowUpRight className="w-4 h-4" /></div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
